import { CSSProperties } from '@material-ui/core/styles/withStyles';
import React from 'react';

interface IProps {
  color?: string;
  width?: number;
  height?: number;
  style?: CSSProperties;
}

const WebcomicIcon = ({ color, width = 16, height = 14, style }: IProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={`0 0 16 14`}
    preserveAspectRatio={width !== 16 && height !== 14 ? 'none' : 'xMidYMid meet'}
  >
    <path
      fill={color || '#000'}
      fillRule="evenodd"
      d="m6.831 9.579.08-2.56a.746.746 0 0 0-.16-.5.548.548 0 0 0-.423-.212H4.333L5.887.737h3.221L7.222 3.935a.788.788 0 0 0-.038.722c.104.23.308.372.53.369l1.675-.03L6.83 9.579zm5.328 1.129a.407.407 0 0 0 .44-.23.415.415 0 0 0-.122-.485c-.956-.749-1.386-1.265-1.357-1.63.04-.488.974-1.062 1.672-1.454a.4.4 0 0 0-.11-.744 19.462 19.462 0 0 1-2.473-.7l.297-.448a.653.653 0 0 0-.557-1.008l-1.86.026 2.1-3.013A.65.65 0 0 0 9.653 0h-4.01a.654.654 0 0 0-.617.444L3.779 4.227a4.288 4.288 0 0 1-1.848-.48.41.41 0 0 0-.557.49c.653 2.133.877 3.23-1.206 4.75a.403.403 0 0 0 .231.731c.569.013 2.089.041 2.3.428.086.158.05.567-.607 1.617a.408.408 0 0 0 .49.595c2.502-.938 3.289-.546 5.096 1.504a.405.405 0 0 0 .71-.295c-.072-.995.185-1.783.74-2.289.65-.586 1.727-.792 3.031-.57z"
    />
  </svg>
);

export default WebcomicIcon;
